import React from "react";
import { Route, Routes } from "react-router-dom";
import Lazy from "./shared/LazyHOC";
import { UnauthenticatedTemplate, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";

const LazyHome = Lazy(React.lazy(() => import("./containers/Home")));

const LazyNotFound = Lazy(React.lazy(() => import("./containers/NotFound")));

const LazyMarketMonitor = Lazy(React.lazy(() => import("./containers/MarketMonitor")));

const LazyActivityMonitor = Lazy(React.lazy(() => import("./containers/ActivityMonitor")));

const LazyCreditMonitor = Lazy(React.lazy(() => import("./containers/CreditMonitor")));
const LazyCreditMonitoringWorkbench = Lazy(React.lazy(() => import("./containers/CreditMonitoringWorkbench")));
const LazyCreditMonitoringCompanyWorkspace = Lazy(
  React.lazy(() => import("./containers/CreditMonitoringCompanyWorkspace")),
);

const LazyPortfolio = Lazy(React.lazy(() => import("./containers/Portfolio")));

const LazyTenantPortal = Lazy(React.lazy(() => import("./containers/TenantPortal")));

function RouterRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LazyHome />} />

      <Route path="*" element={<LazyNotFound />} />

      <Route
        path="/tenant-portal/:key"
        element={
          <UnauthenticatedTemplate>
            <LazyTenantPortal />
          </UnauthenticatedTemplate>
        }
      />

      <Route
        path="/market-monitor/:view"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyMarketMonitor />
          </MsalAuthenticationTemplate>
        }
      />
      <Route
        path="/market-monitor/:view/:parsekey"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyMarketMonitor />
          </MsalAuthenticationTemplate>
        }
      />

      <Route
        path="/activity-monitor/:view"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyActivityMonitor />
          </MsalAuthenticationTemplate>
        }
      />

      <Route
        path="/credit-monitor/workbench/company/:parsekey"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyCreditMonitoringCompanyWorkspace />
          </MsalAuthenticationTemplate>
        }
      />
      <Route
        path="/credit-monitor/workbench"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyCreditMonitoringWorkbench />
          </MsalAuthenticationTemplate>
        }
      />
      <Route
        path="/credit-monitor/workbench/:parsekey"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyCreditMonitoringWorkbench />
          </MsalAuthenticationTemplate>
        }
      />

      <Route
        path="/credit-monitor/:view"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyCreditMonitor />
          </MsalAuthenticationTemplate>
        }
      />
      <Route
        path="/credit-monitor/:view/:parsekey"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyCreditMonitor />
          </MsalAuthenticationTemplate>
        }
      />

      <Route
        path="/portfolio/:view"
        element={
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <LazyPortfolio />
          </MsalAuthenticationTemplate>
        }
      />
    </Routes>
  );
}

export default RouterRoutes;
